import React, { useState, useEffect } from 'react';

const pad2 = (value) => {
  if (value === '' || value === undefined || value === null || isNaN(value)) {
    return '';
  }
  const num = Number(value);
  return num < 10 ? `0${num}` : String(num);
};

const TimeInput = ({ texts, onChangeValue, date }) => {
  const [heure, setHeure] = useState('');
  const [minutes, setMinutes] = useState('');

  const verifierTimeChange = (heureValue, minutesValue) => {
    const heureNum = Number(heureValue);
    const minutesNum = Number(minutesValue);
    if (
      heureValue !== '' && minutesValue !== ''
      && !isNaN(heureNum) && !isNaN(minutesNum)
      && heureNum >= 0 && heureNum < 24
      && minutesNum >= 0 && minutesNum < 60
    ) {
      onChangeValue(heureNum, minutesNum);
    }
  };

  useEffect(() => {
    verifierTimeChange(heure, minutes);
  }, [heure, minutes]);

  // Revalidate the current time when the selected date changes.
  useEffect(() => {
    if (!date) {
      return;
    }
    verifierTimeChange(heure, minutes);
  }, [date]);

  const handleIncrementHeures = (increment) => {
    let newHours = (heure !== '' && !isNaN(Number(heure)) ? Number(heure) : 0) + increment;
    if (newHours > 23) newHours = 0;
    else if (newHours < 0) newHours = 23;
    setHeure(pad2(newHours));
  };

  const handleIncrementMinutes = (increment) => {
    let newMinutes = (minutes !== '' && !isNaN(Number(minutes)) ? Number(minutes) : 0) + increment;
    if (newMinutes > 59) {
      newMinutes = 0;
      handleIncrementHeures(1);
    } else if (newMinutes < 0) {
      newMinutes = 59;
      handleIncrementHeures(-1);
    }
    setMinutes(pad2(newMinutes));
  };

  const onlyDigits = (value) => value.replace(/\D/g, '').slice(0, 2);

  const handleHoursInput = (event) => {
    const digits = onlyDigits(event.target.value);
    if (digits === '') {
      setHeure('');
      return;
    }
    const num = Number(digits);
    if (num >= 0 && num <= 23) {
      setHeure(digits);
    }
  };

  const handleMinutesInput = (event) => {
    const digits = onlyDigits(event.target.value);
    if (digits === '') {
      setMinutes('');
      return;
    }
    const num = Number(digits);
    if (num >= 0 && num <= 59) {
      setMinutes(digits);
    }
  };

  const bloquerNonDigits = (event) => {
    if (event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (allowedKeys.includes(event.key) || /^\d$/.test(event.key)) {
      return;
    }
    event.preventDefault();
  };

  return (
    <div className='container-time-input'>
      <div className="sub-title-section"><span className="droit-acces-span">{texts.timeQuestion}</span></div>
      <div style={{ display: 'flex', alignItems: 'center', width: '12%' }}>
        <div className='content-input-heure'>
          <div className='content-increment'>
            <button type="button" onClick={() => handleIncrementHeures(1)}>▲</button>
          </div>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder='HH'
            maxLength={2}
            value={heure}
            onKeyDown={bloquerNonDigits}
            onChange={handleHoursInput}
            onBlur={() => setHeure(pad2(heure))}
          />
          <div className='content-decrement'>
            <button type="button" onClick={() => handleIncrementHeures(-1)}>▼</button>
          </div>
        </div>
        <span>:</span>
        <div className='content-input-minutes'>
          <div className='content-increment'>
            <button type="button" onClick={() => handleIncrementMinutes(1)}>▲</button>
          </div>
          <div>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder='MM'
              maxLength={2}
              value={minutes}
              onKeyDown={bloquerNonDigits}
              onChange={handleMinutesInput}
              onBlur={() => setMinutes(pad2(minutes))}
            />
          </div>
          <div className='content-decrement'>
            <button type="button" onClick={() => handleIncrementMinutes(-1)}>▼</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeInput;